module.exports = __webpack_public_path__ + "logo-light.png?699b38a9ebd39ab39b8282f3c8ebadd3";


//////////////////
// WEBPACK FOOTER
// ./images/logo-light.png
// module id = 47
// module chunks = 0